import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';

import { ListItemComponent } from '@frontend/sports/common/ui/sports-list-items';
import { TrackReferringACtionDirective } from '@frontend/sports/tracking/feature';
import { QuickLinkViewModel } from '@frontend/sports/types/components/quick-links';
import { Observable } from 'rxjs';

import { QuickLinksSections } from './quick-links.models';
import { QuickLinksService } from './quick-links.service';

@Component({
    imports: [AsyncPipe, ListItemComponent, TrackReferringACtionDirective],
    providers: [QuickLinksService],
    selector: 'ms-quick-links',
    templateUrl: './quick-links.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickLinksComponent implements OnInit {
    links$: Observable<QuickLinkViewModel[]>;

    @Input() section: QuickLinksSections;
    trackingValue = signal<string>('M2_ListItemlinks');
    cleanedAfterTrack = signal(false);

    constructor(private quickLinksService: QuickLinksService) {}

    ngOnInit(): void {
        this.links$ = this.quickLinksService.getQuickLinks(QuickLinksSections[this.section]);
    }

    onLinkClick(link: QuickLinkViewModel): void {
        this.cleanedAfterTrack.update(() => link.link?.indexOf('http') === 0 || false);
        this.quickLinksService.quickLinkClicked$.next(link);
    }
}
